import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import UserDashboard from './pages/user/UserDashboard';
import UserRoutes from './pages/user/UserRoutes';
import UserRouteDetails from './pages/user/UserRouteDetails';
import UserPurchaseOrders from './pages/user/UserPurchaseOrders';
import UserInvoices from './pages/user/UserInvoices';
import UserPayments from './pages/user/UserPayments';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminRoutes from './pages/admin/AdminRoutes';
import AdminRouteDesignate from './pages/admin/AdminRouteDesignate';
import AdminRouteDetails from './pages/admin/AdminRouteDetails';
import AdminUsers from './pages/admin/AdminUsers';
import AdminPurchaseOrders from './pages/admin/AdminPurchaseOrders';
import AdminInvoices from './pages/admin/AdminInvoices';
import AdminPayments from './pages/admin/AdminPayments';
import AdminTransactions from './pages/admin/AdminTransactions';
import AdminDashboardOverview from './pages/admin/AdminDashboardOverview';
import AdminDestinations from './pages/admin/AdminDestinations';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/user" element={<PrivateRoute><UserDashboard /></PrivateRoute>}>
            <Route index element={<UserRoutes />} />
            <Route path="routes" element={<UserRoutes />} />
            <Route path="routes/:id" element={<UserRouteDetails />} />
            <Route path="purchase-orders" element={<UserPurchaseOrders />} />
            <Route path="invoices" element={<UserInvoices />} />
            <Route path="payments" element={<UserPayments />} />
          </Route>
          <Route path="/admin" element={<PrivateRoute adminOnly><AdminDashboard /></PrivateRoute>}>
            <Route index element={<AdminDashboardOverview />} />
            <Route path="routes" element={<AdminRoutes />} />
            <Route path="routes/designate" element={<AdminRouteDesignate />} />
            <Route path="routes/:id" element={<AdminRouteDetails />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="purchase-orders" element={<AdminPurchaseOrders />} />
            <Route path="invoices" element={<AdminInvoices />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="transactions" element={<AdminTransactions />} />
            <Route path="destinations" element={<AdminDestinations />} />
          </Route>
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
